export default {
  "content": "<path d=\"M15.873 10.4H8.127c-.939 0-1.464-.964-.885-1.623l3.873-4.394c.45-.51 1.32-.51 1.77 0l3.873 4.394c.58.659.054 1.623-.885 1.623zm-7.746 3.2h7.746c.939 0 1.464.965.885 1.623l-3.873 4.394c-.45.51-1.32.51-1.77 0l-3.873-4.395c-.58-.657-.054-1.622.885-1.622z\"/>",
  "attrs": {
    "viewBox": "0 0 24 24"
  }
};